import { useState } from 'react';

import { Tooltip } from '@/components/generic';
import {
  DEFAULT_ICON_BUTTON_STYLES,
  DISABLED_ICON_BUTTON_STYLE,
  ICON_BUTTON_STYLES,
  IconButtonVariant
} from '@/components/generic/IconButton/icon-button-config';

type IconButtonType = 'button' | 'submit' | 'reset';

export type IconButtonProps = {
  type?: IconButtonType;
  variant?: IconButtonVariant;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
  handleOnClick?: (e: React.MouseEvent) => void;
  tooltip?: string;
  dataTestId?: string;
};

export const IconButton = ({
  type = 'button',
  variant = IconButtonVariant.PRIMARY,
  children,
  className = '',
  disabled = false,
  handleOnClick,
  tooltip,
  dataTestId
}: IconButtonProps) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const button = (
    <button
      data-testid={dataTestId}
      className={`${DEFAULT_ICON_BUTTON_STYLES} ${ICON_BUTTON_STYLES[variant]} ${className} ${disabled && DISABLED_ICON_BUTTON_STYLE}`}
      onClick={handleOnClick}
      disabled={disabled}
      type={type}>
      {children}
    </button>
  );

  if (tooltip) {
    return (
      <div
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        className='inline-block'>
        <Tooltip
          content={<span className='whitespace-nowrap text-sm'>{tooltip}</span>}
          isVisible={isTooltipVisible}
          onClose={() => setIsTooltipVisible(false)}
          withOverlay={false}>
          {button}
        </Tooltip>
      </div>
    );
  }

  return button;
};
